export const FeralcoInternMixin = {
  methods: {
    fimCalculateLoadedAmount (order) {
      return order.orderRows[0].actions.reduce((acc, curr) => acc + (curr.name === 'Lastar' ? parseFloat(curr.amount === '' ? '0' : curr.amount) : 0), 0)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/FeralcoInternMixin.js